import request from '@/config/axios'

export const getVisitPlanPage = (params: any) =>
  request.get({ url: '/bosscircle/visit-plan/page', params })
export const getVisitPlan = (id: number) =>
  request.get({ url: '/bosscircle/visit-plan/get', params: { id } })
export const closeVisitPlan = (data: any) =>
  request.put({ url: '/bosscircle/visit-plan/close', data })
